import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDataLine = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.45788 13.9255C3.58373 13.6955 5.03771 12.9402 6.03902 11.7774C7.16398 10.471 7.58854 8.77065 7.94528 7.34193L7.94528 7.34193L7.97014 7.24241C8.35797 5.69111 8.69022 4.44052 9.47652 3.5274C10.1986 2.68883 11.4413 1.99987 14 1.99987C14 1.08319 13.3833 0.310544 12.5421 0.0742188C10.4163 0.304231 8.96229 1.05954 7.96098 2.22235C6.83602 3.52875 6.41146 5.2291 6.05472 6.65782L6.05472 6.65782L6.02986 6.75734C5.64203 8.30864 5.30978 9.55922 4.52348 10.4724C3.80138 11.3109 2.55871 11.9999 0 11.9999C0 12.9166 0.616721 13.6892 1.45788 13.9255Z"
	})
});
export default SvgDataLine;
